module.exports = __webpack_public_path__ + "static/media/Urban-Furniture.cf5ce8e0.png";